function init() {
    showSearchFilters();
}

function showSearchFilters() {
    var searchFilterWrapper = document.getElementById('search-result-filters');
    var filterList = document.getElementById('search-result-filters__list');

    if (searchFilterWrapper && filterList) {
        var contentTypes = document.querySelectorAll('.hdn-result-types');
        let sortedTypes = Array.from(contentTypes)
            .sort((a, b) => (a.dataset.weight > b.dataset.weight) ? 1 : -1);

        let totalCount = 0;
        let linkList = [];
        for (let cType of sortedTypes) {
            if (cType.name && cType.value && cType.dataset.label) {
                let urlName = cType.name;
                let currentCount = parseInt(cType.value);

                let li = buildLinkItem(cType.dataset.label, currentCount, urlName.toLowerCase());
                linkList.push(li);

                totalCount += currentCount;
            }
        }

        if (totalCount > 0) {
            searchFilterWrapper.classList.remove('hide');

            let allLink = buildLinkItem('All Results', totalCount);
            filterList.appendChild(allLink);

            for (let link of linkList) {
                filterList.appendChild(link);
            }
        }
    }
}

function buildLinkItem(label, count, urlName) {
    let contentType = getUrlParameter('type');

    var li = document.createElement('li');
    li.classList.add('filter-nav__item');
    if ((contentType && urlName && contentType === urlName) || (!contentType && !urlName)) {
        li.classList.add('is-active');
    }

    var anchor = document.createElement('a');
    anchor.href = getFilterUrl(urlName);
    anchor.text = `${label} (${count})`;
    anchor.classList.add('filter-nav__link');
    li.appendChild(anchor);

    return li;
}

function getFilterUrl(filterType) {
    var uri = location.href;

    filterType = filterType ? filterType : '';
    uri = updateUrlParameter(uri, 'type', filterType);
    uri = updateUrlParameter(uri, 'page', 1);

    return uri;
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

function updateUrlParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    var newUri = uri;
    if (uri.match(re)) {
        newUri = uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        if (value) {
            newUri = uri + separator + key + "=" + value;
        }
    }

    return newUri;
}

export default {
    init: init
}